"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const model_1 = require("../../model");
const react_leaflet_1 = require("react-leaflet");
const react_leaflet_markercluster_1 = __importDefault(require("react-leaflet-markercluster"));
const leaflet_1 = require("leaflet");
const date_fns_1 = require("date-fns");
const hitIcon_1 = __importDefault(require("./hitIcon"));
/**
 * Area displayed by HistMap.
 */
const mapBounds = new leaflet_1.LatLngBounds({ lat: 59.4562, lng: 28.515 }, { lat: 60.4667, lng: 32.2229 });
function addFrontLinePopup(feature, layer) {
    const { description = "", actionHeader = "Линия фронта действовала", dateStart, dateEnd, } = feature.properties;
    layer.bindPopup(description +
        "<br/><br/>" +
        actionHeader +
        " с:<br/>" +
        (dateStart == undefined
            ? "<неизвестно>"
            : (0, date_fns_1.format)((0, model_1.parseFrontLineDate)(dateStart), model_1.DateDisplayFormat)) +
        "</br>по:<br/>" +
        (dateEnd == undefined
            ? "<неизвестно>"
            : (0, date_fns_1.format)((0, model_1.parseFrontLineDate)(dateEnd), model_1.DateDisplayFormat)));
}
function setFrontLineStyle(feature) {
    if (feature == null) {
        return {};
    }
    return feature.properties;
}
function renderGeoJSONs(jsons) {
    return jsons.map((json, index) => (react_1.default.createElement(react_leaflet_1.GeoJSON, { data: json, key: index, style: setFrontLineStyle, onEachFeature: addFrontLinePopup })));
}
/**
 * Leaflet map that will display artillery hits and modern Saint-Petersburg map.
 */
const HistMap = react_1.default.memo(function HistMap(props) {
    const { hits, geojsons, className } = props;
    return (react_1.default.createElement(react_leaflet_1.MapContainer, { center: [59.9227, 30.3353], zoom: 9, scrollWheelZoom: true, zoomControl: false, className: className, maxBounds: mapBounds, minZoom: 9 },
        react_1.default.createElement(react_leaflet_1.TileLayer, { url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", attribution: '\u00A9 <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' }),
        renderGeoJSONs(geojsons),
        react_1.default.createElement(react_leaflet_markercluster_1.default, null, hits.map((hit, index) => (react_1.default.createElement(react_leaflet_1.Marker, { position: (0, model_1.asArray)(hit.position), key: index, icon: (0, hitIcon_1.default)(hit) },
            react_1.default.createElement(react_leaflet_1.Popup, null,
                "\u0414\u0430\u0442\u0430: ",
                (0, date_fns_1.format)(hit.date, model_1.DateDisplayFormat),
                " ",
                react_1.default.createElement("br", null),
                " \u0410\u0434\u0440\u0435\u0441:",
                " ",
                hit.address.street,
                ", ",
                hit.address.houseNumber,
                " ",
                react_1.default.createElement("br", null),
                "\u0422\u0438\u043F: ",
                (0, model_1.hitTypeText)(hit.type),
                " ",
                react_1.default.createElement("br", null),
                hit.description && `Описание: ${hit.description}`)))))));
});
exports.default = HistMap;
